import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PickupAddressConstants } from '../store/pickupAddress.constants'
import * as pickupAddressActions from '../store/pickupAddress.actions'
import { setRefDefaults } from './setPickupAddressDefaults.saga'
import { IPickupAddressState } from '../store/pickupAddress.types'
import { getPickupAddressSelector } from '../selectors'

export function* setPickupAddressDefaultsWithResponseMode() {
  try {
    const pcrID: string = yield select(getPcrIdSelector)
    const serviceId: string = yield select(getServiceIdSelector)

    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pickupAddress: IPickupAddressState = yield select(getPickupAddressSelector)

      // Check if defaults are set or if pickup address exists
      if (!pcrDoc.patient?.pickupAddress?.__areDefaultsSet && !pcrDoc.patient?.pickupAddress) {
        // Set defaults first
        yield call(setRefDefaults, pcrDoc)
      }

      // Create new pickup address from existing data and add response mode
      const updatedPickupAddress = {
        ...pcrDoc.patient?.pickupAddress,
        responseMode: pickupAddress.responseMode,
        __areDefaultsSet: true,
      }

      // Update the PCR document with the new pickup address
      const updatedPcrDoc = {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          pickupAddress: updatedPickupAddress,
        },
      }

      // Save the updated PCR document
      yield call([pcrDocsService, pcrDocsService.savePCR], updatedPcrDoc)

      // Update the Redux state
      yield put(pickupAddressActions.setPickupAddressState(updatedPickupAddress))
    }
  } catch (e) {
    yield put(throwPcrException(`setPickupAddressDefaultsWithResponseMode() error: ${e}`))
  }
}

export function* setPickupAddressDefaultsWithResponseModeSaga() {
  yield takeLatest(
    [PickupAddressConstants.SET_PICKUP_ADDRESS_DEFAULTS_WITH_RESPONSE_MODE],
    performWithMutexHOG,
    setPickupAddressDefaultsWithResponseMode
  )
}
